import { Button } from '@/components/ui/button'
import { CheckCircle2, Calendar, MapPin } from 'lucide-react'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'

export function BookingConfirmation({ flow }: { flow: any }) {
  const { date, time, company } = flow

  return (
    <div className="space-y-6 animate-in zoom-in-95 duration-500 flex flex-col items-center justify-center text-center py-8">
      <div className="w-20 h-20 bg-green-500/20 rounded-full flex items-center justify-center mb-4">
        <CheckCircle2 className="w-10 h-10 text-green-500" />
      </div>
      
      <h2 className="text-2xl font-bold text-slate-100">Agendamento Confirmado!</h2>
      <p className="text-slate-400">
        Seu horário foi reservado com sucesso.
      </p>

      <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-5 w-full text-left space-y-4 mt-6">
        <div className="flex items-start gap-3">
          <Calendar className="w-5 h-5 text-blue-400 mt-0.5" />
          <div>
            <p className="font-semibold text-slate-100 capitalize">
              {format(date, "EEEE, dd 'de' MMMM", { locale: ptBR })} às {time}
            </p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <MapPin className="w-5 h-5 text-blue-400 mt-0.5" />
          <div>
            <p className="font-semibold text-slate-100">{company?.name}</p>
            {company?.address && (
              <p className="text-sm text-slate-400">{company.address}</p>
            )}
          </div>
        </div>
      </div>

      <div className="w-full space-y-2 mt-8">
        <Button className="w-full" onClick={() => window.location.reload()}>
          Fazer novo agendamento
        </Button>
      </div>
    </div>
  )
}
